export default "__VITE_ASSET__XIprsYye__"